import reportRegimeHelper from "../helpers/report/reportRegime/reportRegimeHelper";

const reportRegime: { [key: string]: any } = Object.fromEntries(reportRegimeHelper.getRegimes());

const reportRegimesWithoutDeprecated:{ [key: string]: any } = Object.fromEntries(reportRegimeHelper.getRegimesWithoutDeprecated());

export { reportRegime, reportRegimesWithoutDeprecated };
